export default __webpack_public_path__ + "static/media/full_TheRaveling.0bd56cac.jpg";